<div mat-dialog-content>
    <p>{{featureName}} feature not enabled. Contact Masterloop to enable.</p>
</div>
<a class="close-btn" (click)="onNoClick()">
    <img src="assets/images/close.svg" />
</a>